class AnimatedSearchText extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.index = 1 // We start on 1 as the first term is already visible
    this.delay = 5500
  }

  connectedCallback () {
    super.connectedCallback()

    this.searchTerms = this.querySelectorAll('.hd-Banner_AnimatedSearchTerm')

    setInterval(this.cycleSearchTerms.bind(this), this.delay)
  }

  cycleSearchTerms () {
    this.searchTerms.forEach((searchTerm, index) => {
      if (index === this.index) {
        searchTerm.setAttribute('data-visible', true)
      } else {
        searchTerm.removeAttribute('data-visible')
      }
    })

    this.index = (this.index + 1) % this.searchTerms.length
  }
}

if (!customElements.get('animated-search-text')) {
  customElements.define('animated-search-text', AnimatedSearchText)
}
